import { IPlayerDataLabels, ITeamProfileStatistics } from '../../../../packages/types';
import { teamStatisticLabels } from '../../../docs/.storybook/labels-value';

const DEFAULT_STATISTICS = ['played', 'win', 'draw', 'defeats', 'goals_scored', 'goals_conceded'];

export const getTeamStatisticRows = (statistics: ITeamProfileStatistics, scheme?: string[], dataLabels?: IPlayerDataLabels) => {
  const statRowsPositions = !scheme || scheme.length < 3 ? DEFAULT_STATISTICS : scheme;

  const defaultLabels = teamStatisticLabels as IPlayerDataLabels;

  const rows = statRowsPositions
    .map((statName) => {
      const name = dataLabels && dataLabels[statName] ? dataLabels[statName] : defaultLabels[statName];
      const value = statistics[statName as keyof ITeamProfileStatistics]?.toString();
      return { name: name ?? '', value: value ?? '-' };
    })
    .slice(0, 6);

  return rows;
};
